import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-tisco-block-calculate-link',
    templateUrl: './tisco-block-calculate-link.component.html',
    styleUrls: ['./tisco-block-calculate-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TiscoBlockCalculateLinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
